// ─────────────────────────────────────────────────────────────
// SITE CONTENT CONFIG — the creator edits THIS ONE FILE.
// Everything below marked [placeholder] is a stand-in value:
// swap in the real name, email, handles, brands, stats, quotes.
// ─────────────────────────────────────────────────────────────

export const SITE = {
  name: "Devora",
  eyebrow: "AI UGC Creator / Creative Partner",
  niche: "Beauty & Skincare",
  headline: "Content that feels real — because it is.",
  headlineLead: "AI UGC That Makes Brands",
  headlineMuted: "Impossible to Ignore.",
  subheadline:
    "I create scroll-stopping AI-powered UGC ads and creative content designed to help brands showcase their products — and turn attention into revenue.",
  heroTags: ["UGC", "AI Ads", "Product Creatives", "Social Media Content"],
  availabilityBadge: "Available for select projects",
  availabilityLine: "Creative that earns a second look.",
  proofChips: ["48-hour turnaround", "Usage rights included", "Raw + edited files delivered"],
  trustLine: "Rated 5.0 by partner brands",
  location: "Remote — working with brands worldwide",
  email: "team.devorashop@gmail.com",
  instagram: "@devorashop.in",
  tiktok: "", // [placeholder] add TikTok handle when ready — hidden until set
  whatsapp: "918368537485",
  whatsappMessage: "Hi Devora! I'd like to discuss a UGC project for my brand.",
  instagramUrl: "https://www.instagram.com/devorashop.in/",
  tiktokUrl: "", // [placeholder] add real profile URL
  bookingUrl: "", // [placeholder] optional Calendly-style link — leave empty to use the contact form
  aboutBio:
    "I'm Devora, an AI UGC creator focused on creating premium, attention-grabbing content for modern brands.",
  aboutBio2:
    "I combine AI-powered production with creative storytelling to create UGC-style advertisements and product content that feels native to social media while maintaining a premium brand aesthetic.",
  stats: [
    { value: "24+", label: "Brands created for" },
    { value: "12M+", label: "Views generated" },
    { value: "3+", label: "Years creating UGC" },
  ],
  trustedBrands: ["LUMIÈRE", "VELVET & CO", "MAISON NORD", "ATELIER 9", "PURE FORM"], // [placeholder] wordmarks — swap for real logos
  // Sample case studies — demonstration content, labeled "Sample" on each card.
  clientResults: [
    {
      brand: "Glow Theory",
      category: "Beauty & Skincare",
      rating: 5,
      made: "Serum unboxing + morning-routine hook video",
      used: "Instagram Reels and Meta ads",
      result: "Became their most-saved Reel; buying DMs rose within the first week",
    },
    {
      brand: "Urban Loom",
      category: "Fashion & Apparel",
      rating: 5,
      made: "Try-on and styling clips showing drape and fit",
      used: "Meta ads and website catalog",
      result: "Stronger ad engagement and fewer fit-related returns",
    },
    {
      brand: "Munch House",
      category: "Food & Beverage",
      rating: 5,
      made: "Taste-test video with a natural first-bite reaction",
      used: "Spark-style paid ads and distributor outreach",
      result: "Retailers referenced the video during reorders",
    },
    {
      brand: "FlexNest",
      category: "Fitness & Wellness",
      rating: 5,
      made: "In-use demos of resistance band and mat in a real home",
      used: "Product pages and Instagram",
      result: "Longer product-page sessions; fewer how-to queries",
    },
    {
      brand: "TechNest",
      category: "Tech & Gadgets",
      rating: 5,
      made: "Unboxing with a first-setup walkthrough",
      used: "Order-confirmation emails and social ads",
      result: "First-time-setup support tickets dropped noticeably",
    },
    {
      brand: "Casa Aroma",
      category: "Home & Decor",
      rating: 5,
      made: "Evening-light home-styling videos with candles and ceramics",
      used: "Instagram Reels and festive-season ads",
      result: "Customers mentioned the videos while ordering",
    },
    {
      brand: "Silverline Jewels",
      category: "Jewellery & Accessories",
      rating: 5,
      made: "Close-up styling clips — earrings worn, rings catching light",
      used: "Instagram ads and product pages",
      result: "Ad comments shifted from price questions to purchase intent",
    },
  ],
  // Replace with genuine client quotes (with permission) as real projects close.
  testimonials: [
    {
      category: "Beauty & Skincare",
      business: "D2C skincare brand — Jaipur",
      mark: "SK",
      name: "Priya Sharma",
      role: "Founder",
      rating: 5,
      quote: "We sent over our new vitamin C serum and got three short videos back — an unboxing, a texture demo and a morning-routine hook. The routine video became our most-saved Reel that month.",
      made: "Unboxing, texture demo, routine hook — 3 vertical videos",
      used: "Instagram Reels and the product page",
      result: "Most-saved post of the month; more buying DMs within the first week",
    },
    {
      category: "Beauty & Skincare",
      business: "Salon & cosmetics label — Lucknow",
      mark: "SC",
      name: "Rohit Verma",
      role: "Owner",
      rating: 5,
      quote: "We'd only ever posted static photos before. The before-and-after style clips felt like real customers talking, not ads. Our WhatsApp enquiries picked up noticeably during the two weeks we posted them.",
      made: "Testimonial-style clips + service demo — 4 vertical videos",
      used: "Instagram, WhatsApp status and in-store screen",
      result: "Visible lift in WhatsApp enquiries during the posting weeks",
    },
    {
      category: "Fashion & Apparel",
      business: "Ethnic wear startup — Surat",
      mark: "EW",
      name: "Anjali Desai",
      role: "Co-founder",
      rating: 5,
      quote: "The try-on style videos showed the drape and fit better than any photoshoot we'd done. We used them in Meta ads and on our catalog — returns due to 'fit expectations' came down a little, which we didn't expect.",
      made: "Try-on and styling videos — 5 vertical clips",
      used: "Meta ads and website catalog",
      result: "Better ad engagement; slightly fewer fit-related returns",
    },
    {
      category: "Fashion & Apparel",
      business: "Streetwear label — New Delhi",
      mark: "SW",
      name: "Arjun Mehta",
      role: "Marketing Lead",
      rating: 5,
      quote: "Drop day content used to take us a week to plan. The hook-first clips were ready before the drop and felt native to the feed. Our launch Reel reached roughly double our usual audience.",
      made: "Hook-led launch clips — 3 vertical videos",
      used: "Instagram Reels and TikTok-style shorts",
      result: "Launch Reel reached about 2x the account's usual audience",
    },
    {
      category: "Food & Beverage",
      business: "Packaged snacks brand — Indore",
      mark: "PS",
      name: "Kavita Joshi",
      role: "Founder",
      rating: 5,
      quote: "The taste-test video looked like something a friend would post. We ran it as a Spark-style ad and also sent it to our distributors to show the product story. A few retailers mentioned the video when reordering.",
      made: "Taste-test and pantry-stocking clips — 3 videos",
      used: "Paid social ads and distributor outreach",
      result: "Retailers referenced the video during reorders",
    },
    {
      category: "Food & Beverage",
      business: "Café chain — Bengaluru",
      mark: "CC",
      name: "Nikhil Rao",
      role: "Operations Head",
      rating: 5,
      quote: "Short menu-prep clips — the pour, the plating, the first bite. Nothing scripted. Weekend footfall on the featured items improved enough that the staff noticed and asked which video was running.",
      made: "Menu-prep and ambience clips — 4 vertical videos",
      used: "Instagram Reels and Google Business profile",
      result: "Noticeable weekend lift on featured menu items",
    },
    {
      category: "Fitness & Wellness",
      business: "Yoga equipment store — Pune",
      mark: "YE",
      name: "Sneha Kulkarni",
      role: "Founder",
      rating: 5,
      quote: "We struggle to explain our products with photos. The demo videos showed the resistance band and mat in actual use, in a real living room. Product-page visitors started watching instead of bouncing.",
      made: "In-use product demos — 3 vertical videos",
      used: "Product pages and Instagram",
      result: "Longer product-page sessions; fewer 'how does this work' queries",
    },
    {
      category: "Tech & Gadgets",
      business: "D2C gadget startup — Bengaluru",
      mark: "GT",
      name: "Vikram Iyer",
      role: "Co-founder & CEO",
      rating: 5,
      quote: "For a small startup, the unboxing-with-setup video did double duty — marketing content and a soft onboarding guide. Support tickets about first-time setup dropped after we added it to the confirmation email.",
      made: "Unboxing + setup walkthrough — 2 videos",
      used: "Order-confirmation email and social ads",
      result: "Fewer first-time-setup support tickets",
    },
    {
      category: "Home & Decor",
      business: "Home fragrance & decor brand — Ahmedabad",
      mark: "HD",
      name: "Meera Pillai",
      role: "Founder",
      rating: 5,
      quote: "Candles and ceramics are hard to sell online because people can't smell or touch them. The styling videos showed our products in real homes, in evening light. Customers started mentioning the videos when they ordered.",
      made: "Home-styling and ambience videos — 3 vertical clips",
      used: "Instagram Reels and festive-season ads",
      result: "Customers referencing the videos while ordering; stronger festive campaign engagement",
    },
    {
      category: "Jewellery & Accessories",
      business: "Silver jewellery label — Mumbai",
      mark: "SJ",
      name: "Aditi Shah",
      role: "Creative Director",
      rating: 5,
      quote: "Jewellery photography always looked flat for us. The close-up styling clips — earrings being worn, rings catching light — finally showed the finish properly. Ad comments shifted from 'price?' to 'link please'.",
      made: "Close-up styling and wearability clips — 4 vertical videos",
      used: "Instagram ads and product pages",
      result: "Ad comments shifted from price questions to purchase intent",
    },
    {
      category: "Health & Wellness",
      business: "Ayurvedic supplements brand — Kochi",
      mark: "AS",
      name: "Thomas George",
      role: "Marketing Manager",
      rating: 4,
      quote: "In our category, trust is everything. The routine-style videos explained how and when to use the product without sounding like a medical claim. Our ad account's cost per purchase improved over the following month.",
      made: "Daily-routine explainer videos — 3 vertical videos",
      used: "Meta ads and WhatsApp broadcasts",
      result: "Cost per purchase improved over the following month",
    },
    {
      category: "Consumer Electronics",
      business: "Mobile accessories brand — Noida",
      mark: "MA",
      name: "Sahil Kapoor",
      role: "E-commerce Lead",
      rating: 5,
      quote: "We compete with hundreds of similar listings. The demo videos showed the product surviving drops and daily use, which specs alone never convey. Our marketplace listing conversion improved after adding them.",
      made: "Durability demo and unboxing clips — 3 videos",
      used: "Amazon listing, Flipkart ads and Instagram",
      result: "Better marketplace listing conversion after adding the videos",
    },
  ],
  portraitUrl:
    "https://images.unsplash.com/photo-1521146764736-56c929d59c83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxhZXN0aGV0aWMlMjBza2luY2FyZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDA3MDkyOHww&ixlib=rb-4.1.0&q=85", // [placeholder] swap for the creator's real portrait
};

export const SERVICES = [
  { icon: "sparkles", title: "AI UGC Ads", description: "Authentic creator-style ads powered by AI for high-converting social campaigns." },
  { icon: "video", title: "Product Videos", description: "Sleek product visualizers that make the details and benefits impossible to miss." },
  { icon: "megaphone", title: "Social Media Ads", description: "Hook-driven vertical content tailored for TikTok, Reels, and Shorts." },
  { icon: "image", title: "AI Product Creatives", description: "Generative concepts placing your product in elevated, believable lifestyle scenes." },
  { icon: "pen", title: "Ad Creative Concepts", description: "Hooks, scripts, visual direction, and complete creative angles built around your product." },
];

export const WHY_ME = [
  { icon: "sparkles", title: "AI-powered production", description: "More creative routes, without the traditional production drag." },
  { icon: "clock", title: "Fast turnaround", description: "Clear communication and focused delivery from brief to final." },
  { icon: "target", title: "Scroll-stopping concepts", description: "Hooks and visual worlds designed for the first second of attention." },
  { icon: "heart", title: "Brand-focused storytelling", description: "Social-native work that still feels unmistakably like your brand." },
  { icon: "check", title: "Social-first content", description: "Creative built for how people actually watch, save, and share today." },
];

export const PROCESS_STEPS = [
  { step: "01", title: "Brief", description: "You share your product, goals, audience, and requirements." },
  { step: "02", title: "Concept", description: "I develop the hook, script, creative angle, and visual direction." },
  { step: "03", title: "Create", description: "I produce the AI-powered UGC or product creative with care." },
  { step: "04", title: "Deliver", description: "You receive polished, ready-to-use content for your next campaign." },
];

export const CATEGORIES = ["AI UGC", "Product Ads", "Beauty", "Tech", "Lifestyle", "Fashion", "Unboxing", "Testimonial", "Demo", "Hook", "Ad"];

export const WA_LINK = SITE.whatsapp
  ? `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`
  : "#contact";
